module.exports = __webpack_public_path__ + "img/tools_banner.43586363.jpg";